var PageSmartupBuyResult = (function ($) {

    PageSmartupBuyResult = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$content_wrapper = that.$wrapper.find('.js-smartup-order-checkout-result-content-wrapper');

        // CONST
        that.action = options['action'];

        that.smartup_order_hash = options['smartup_order_hash'];
        that.modal_error = options['modal_error'];
        that.smartup_order_url = $.sa.build_url('my/smartup');

        that.analytics_data = options['analytics_data'] || null;

        // DYNAMIC VARS
        that.status = null;
        that.is_locked = false;

        // INIT
        that.init();
    };

    PageSmartupBuyResult.prototype.init = function () {
        var that = this;

        if (that.action !== 'success') {
            that.__sendResultPostMessage(false);
            return false;
        }

        //
        that.initPaymentStatusChecker();
    };

    PageSmartupBuyResult.prototype.initPaymentStatusChecker = function () {
        var that = this,
            smartup_status = null,
            href = $.sa.build_url('smartup/buy/status'),
            data = {
                smartup_order_hash: that.smartup_order_hash,
            };

        var success_statuses = [
            'issue_processing_failure',
            'issued'
        ];

        // GA event. Начало выписки smartUp на нашей стороне
        $.sa.analytics.gtagSelectContent('page', 'smartup_processing');

        var counter = 0,
            is_locked = false,
            timer = setInterval(function () {
                if (is_locked) {
                    return;
                }

                if (counter >= 240) {
                    clearInterval(timer);
                    that.__handleFinish();
                } else {
                    is_locked = true;

                    $.post(href, data, function (res) {
                        if (res && res.data && res.data.status && res.data.status) {
                            smartup_status = res.data.status;
                        }
                        if ($.inArray(smartup_status, success_statuses) !== -1) {
                            clearInterval(timer);
                            if (smartup_status === 'issue_processing_failure') {
                                that.__sendResultPostMessage(false);
                                that.$content_wrapper.hide();
                                $.uiModal({
                                    html: that.modal_error,
                                    onBgClick: function (modal, event) {
                                        event.preventDefault();
                                        return false;
                                    },
                                    onClose: function () {
                                        that.__handleFinish();
                                    }
                                });
                            } else {
                                that.__sendResultPostMessage(true);
                                that.__handleFinish();
                            }
                        }
                        is_locked = false;
                    });
                    counter++;
                }
            }, 2500);
    };

    PageSmartupBuyResult.prototype.__handleFinish = function () {
        var that = this;

        if(that.analytics_data) {
            $.sa.analytics.gtag('event', 'purchase', that.analytics_data);
        }

        // use a standard redirect with `window.location.href` instead `$.sa.content_router.load()`
        // because it's necessary to refresh Smart Up blocks in the header and footer
        // after success payment
        window.location.href = that.smartup_order_url;
    };

    /**
     * The method is needed in case we did not receive a postmessage from the payment gateway from the iframe.
     *
     * @param is_success
     * @private
     */
    PageSmartupBuyResult.prototype.__sendResultPostMessage = function (is_success) {
        var that = this;

        $.sa.postMessage({
            type: 'AviaIframeResult',
            data: {
                success: is_success
            }
        });
    };

    return PageSmartupBuyResult;
})($);
